"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const typesConstants_1 = require("../../constants/typesConstants");
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const messageComponent_1 = __importDefault(require("../../components/messageComponent/messageComponent"));
const colors_1 = __importDefault(require("../../styles/colors"));
const userCustomerInfo_1 = __importDefault(require("../../components/customerInfo/userCustomerInfo"));
const otherLoansContent_1 = __importDefault(require("../../components/loanDetails/otherLoansTabContent/otherLoansContent"));
const actionHistoryTable_1 = __importDefault(require("../../components/historyBox/actionHistoryTable/actionHistoryTable"));
const userActions_1 = __importDefault(require("../../components/customerInfo/userActions/userActions"));
const userTickets_1 = __importDefault(require("../../components/customerInfo/userTickets/userTickets"));
const defaultProps = {
    displayActions: true,
};
const UserComponent = () => {
    const { schedule, user, loadingStatus, errorMessage } = useAppSelector_1.default((state) => ({
        loadingStatus: state.schedule.status,
        callerInbound: state.communication.callerInbound,
        schedule: state.schedule.schedule,
        user: state.schedule.user,
        errorMessage: state.schedule.errorMessage,
    }));
    const isDesktop = useWebDesktopDesign_1.default();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    if (loadingStatus === typesConstants_1.FAILED_STATUS)
        return react_1.default.createElement(messageComponent_1.default, { message: errorMessage, color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loadingStatus === typesConstants_1.PENDING_STATUS && react_1.default.createElement(spinner_1.default, null),
        !!user && !!schedule && (react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(userCustomerInfo_1.default, { user: user }),
            react_1.default.createElement(userActions_1.default, { user: user, scheduleId: schedule.id }),
            react_1.default.createElement(userTickets_1.default, { user: user }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                react_1.default.createElement(otherLoansContent_1.default, { otherLoans: user.loans })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
                react_1.default.createElement(actionHistoryTable_1.default, { historyActions: user.communication_history }))))));
};
UserComponent.defaultProps = defaultProps;
exports.default = UserComponent;
